import { useAdminSimple } from '@/hooks/useAdminSimple';
import { useNavigate } from 'react-router-dom';
import { Shield } from 'lucide-react';

const AdminBadge = () => {
  const { isAdmin, loading } = useAdminSimple();
  const navigate = useNavigate();

  if (loading || !isAdmin) return null;

  return (
    <button
      onClick={() => navigate('/admin')}
      className="fixed bottom-4 right-4 z-50 flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary/10 border border-primary/20 text-primary text-xs font-semibold backdrop-blur-sm hover:bg-primary/20 transition-colors no-print"
    >
      <Shield className="w-3.5 h-3.5" />
      Admin Mode
    </button>
  );
};

export default AdminBadge;
